var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnytime3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.538 6.3183C37.4696 5.82835 37.1163 5.42533 36.6388 5.29287L21.3335 1.04545C21.1153 0.98485 20.8848 0.98485 20.6665 1.04545L5.36121 5.29287C4.88366 5.42533 4.5304 5.82818 4.46204 6.3183C4.37327 6.95528 2.3481 22.0057 7.54251 29.4928C12.7308 36.971 20.3846 38.8874 20.7078 38.9654C20.8039 38.9886 20.9018 39 21 39C21.0982 39 21.1961 38.9884 21.2922 38.9654C21.6156 38.8874 29.2694 36.971 34.4575 29.4928C39.6519 22.0059 37.6267 6.95544 37.538 6.3183ZM30.8699 15.1049L20.4302 25.5226C20.1873 25.765 19.8687 25.8864 19.5503 25.8864C19.2319 25.8864 18.9133 25.7652 18.6704 25.5226L12.2156 19.0814C11.9821 18.8486 11.851 18.5327 11.851 18.2034C11.851 17.874 11.9823 17.5581 12.2156 17.3253L13.4972 16.0464C13.9832 15.5615 14.7712 15.5614 15.257 16.0464L19.5503 20.3305L27.8285 12.0697C28.0618 11.8367 28.3784 11.7059 28.7084 11.7059C29.0384 11.7059 29.355 11.8367 29.5883 12.0697L30.8699 13.3486C31.3559 13.8336 31.3559 14.6199 30.8699 15.1049Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnytime3);
export default __webpack_public_path__ + "static/media/anytime3.1a65829aa514f96aaec2e36c439ad615.svg";
export { ForwardRef as ReactComponent };